module.exports = __webpack_public_path__ + "img/csr_110923_H.77e5d786.jpg";